'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('slick-carousel');

var leftBlackArrow = 'https://cdn.shopify.com/s/files/1/0377/2037/t/37/assets/left-arrow-black.svg?1994058';
var rightBlackArrow = 'https://cdn.shopify.com/s/files/1/0377/2037/t/37/assets/right-arrow-black.svg?1994058';
var leftWhiteArrow = '{{ "arrow-left-white.svg" | asset_url }}';
var rightWhiteArrow = '{{ "arrow-right-white.svg" | asset_url }}';

var tileCarouselThreeSettings = {
  slidesToShow: 3,
  rows: 0,
  centerMode: true,
  centerPadding: '60px',
  arrows: false,
  responsive: [{
    breakpoint: 768,
    settings: {
      slidesToShow: 2,
      arrows: false
    }
  }, {
    breakpoint: 600,
    settings: {
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '60px',
      arrows: false
    }
  }]
};

var tileCarouselFourSettings = {
  slidesToShow: 4,
  rows: 0,
  // centerMode: true,
  arrows: true,
  prevArrow: $('[data-home-tiles-prev]'),
  nextArrow: $('[data-home-tiles-next]'),
  responsive: [{
    breakpoint: 992,
    settings: {
      slidesToShow: 3
      // arrows: false,
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 2
      // arrows: false,
    }
  }, {
    breakpoint: 600,
    settings: {
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '60px',
      arrows: false
    }
  }]
};

var featuredProductsSettings = {
  centerMode: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  swipeToSlide: true,
  accessibility: false,
  // rows: 0,
  // variableWidth: true,
  responsive: [{
    breakpoint: 1279,
    settings: {
      centerMode: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      draggable: true,
      swipeToSlide: true,
      arrows: false,
      accessibility: false,
      rows: 0
    }
  }, {
    breakpoint: 600,
    settings: {
      centerMode: true,
      slidesToShow: 1,
      draggable: true,
      swipeToSlide: true,
      accessibility: false,
      arrows: true,
      prevArrow: '<button aria-label="next slide" class=\'product-carousel__control slick-prev\'><i class="fa fa-chevron-left"></i></button>',
      nextArrow: '<button aria-label="previous slide" class=\'product-carousel__control slick-next\'><i class="fa fa-chevron-right"></i></button>',
      rows: 0
    }
  }]
};

var jsExploreSettings = {
  centerMode: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  swipeToSlide: true,
  rows: 0,
  prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
  nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
  responsive: [{
    breakpoint: 1300,
    settings: {
      centerMode: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      draggable: true,
      swipeToSlide: true,
      rows: 0,
      arrows: false
    }
  }, {
    breakpoint: 991,
    settings: {
      centerMode: true,
      rows: 0,
      slidesToShow: 3,
      slidesToScroll: 3,
      draggable: true,
      swipeToSlide: true,
      arrows: false
    }
  }, {
    breakpoint: 768,
    settings: {
      centerMode: true,
      rows: 0,
      slidesToShow: 2,
      slidesToScroll: 2,
      draggable: true,
      swipeToSlide: true,
      arrows: false
    }
  }, {
    breakpoint: 600,
    settings: {
      centerMode: true,
      rows: 0,
      slidesToShow: 1,
      draggable: true,
      swipeToSlide: true,
      arrows: false,
      prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>'
    }
  }]
};

exports.default = {
  init: function init() {
    if ($('[data-homepage-slider].grid-three').length) {
      $('[data-homepage-slider].grid-three').each(function (index, element) {
        $(element).not('.slick-initialized').slick(tileCarouselThreeSettings);
      });
    }

    if ($('[data-homepage-slider].grid-four').length) {
      $('[data-homepage-slider].grid-four').each(function (index, element) {
        $(element).not('.slick-initialized').slick(tileCarouselFourSettings);
      });
    }

    if ($('.js-explore-by-series-slider').length) {
      $('.js-explore-by-series-slider').each(function (index, element) {
        $(element).not('.slick-initialized').slick(jsExploreSettings);
      });
    }

    if ($('[data-home-featured-products]').length) {
      $('[data-home-featured-products]').each(function (index, element) {
        var $sliderParent = $(element);
        var $slider = $sliderParent.find('[data-featured-products-slider]');

        $slider.not('.slick-initialized').slick(featuredProductsSettings);

        var $controlsWrapper = $sliderParent.find('[data-featured-products-slider-controls]');
        var $controlPrev = $controlsWrapper.find('[data-featured-products-slider-prev]');
        var $controlNext = $controlsWrapper.find('[data-featured-products-slider-next]');

        $controlNext.on('click', function () {
          $slider.slick('slickNext');
        });

        $controlPrev.on('click', function () {
          $slider.slick('slickPrev');
        });

        if ($slider.find('[data-variant-id]').length < 4) {
          $controlPrev.hide();
          $controlNext.hide();
        }
      });
    }

    if ($('[data-homepage-slider].grid-three').length) {
      $('[data-homepage-slider].grid-three').each(function (index, element) {
        $(element).not('.slick-initialized').slick(tileCarouselThreeSettings);
      });
    }

    if ($('[data-homepage-slider].grid-four').length) {
      $('[data-homepage-slider].grid-four').each(function (index, element) {
        $(element).not('.slick-initialized').slick(tileCarouselFourSettings);
      });
    }

    if ($('.js-explore-by-series-slider').length) {
      $('.js-explore-by-series-slider').each(function (index, element) {
        $(element).not('.slick-initialized').slick(jsExploreSettings);
      });
    }

    if ($('[data-skc-slider]').length) {
      $('[data-skc-slider]').each(function (index, element) {
        $(element).not('.slick-initialized').slick({
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '5%',
          infinite: false,
          responsive: [{
            breakpoint: 992,
            settings: {
              arrows: true,
              prevArrow: '<div class=\'slide-left\'><img src=\'' + leftBlackArrow + '\'></div>',
              nextArrow: '<div class=\'slide-right\'><img src=\'' + rightBlackArrow + '\'></div>',
              centerMode: false,
              centerPadding: 0
            }
          }]
        });
      });
    }

    if ($('[data-sk-slider-white]').length) {
      $('[data-sk-slider-white]').each(function (index, element) {
        $(element).not('.slick-initialized').slick({
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '5%',
          infinite: false,
          responsive: [{
            breakpoint: 992,
            settings: {
              arrows: true,
              prevArrow: '<div class=\'slide-left\'><img src=\'' + leftWhiteArrow + '\'\'></div>',
              nextArrow: '<div class=\'slide-right\'><img src=\'' + rightWhiteArrow + '\'></div>',
              centerMode: false,
              centerPadding: 0
            }
          }]
        });
      });
    }

    // eslint-disable-next-line func-names
    $('[data-skc-slider], [data-sk-slider-white]').on('afterChange', function (slick, currentSlide) {
      // console.log(slick);
      var numOfSlides = slick.$slider.find('.slick-slide').length - 1;

      if (currentSlide === 0) {
        slick.$slider.find('.slide-left').css('visibility', 'hidden');
        slick.$slider.find('.slide-right').css('visibility', 'visible');
      } else if (currentSlide === numOfSlides) {
        slick.$slider.find('.slide-right').css('visibility', 'hidden');
        slick.$slider.find('.slide-left').css('visibility', 'visible');
      } else {
        slick.$slider.find('.slick-arrow').css('visibility', 'visible');
      }
    });

    if ($('[data-product-upsells]').not('.slick-initialized').length) {
      $('[data-product-upsells]').slick({
        rows: 0,
        arrows: true,
        slidesToShow: 3,
        infinite: false,
        nextArrow: '<button class="slick-next slick-arrow" aria-label="go to next slide" type="button"><svg class="slick-arrow__icon" width="9" height="14" viewBox="0 0 9 14" xmlns="http://www.w3.org/2000/svg"><path d="M1.6855 0L0 1.63333 5.53808 7 0 12.36667 1.6855 14l7.22359-7z" fill="#2B2B2B" fill-rule="evenodd"/></svg></button>',
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="go to previous slide" type="button"><svg class="slick-arrow__icon" width="9" height="14" viewBox="0 0 9 14" xmlns="http://www.w3.org/2000/svg"><path d="M7.22359 0l1.6855 1.63333L3.37101 7l5.53808 5.36667L7.22359 14l-7.2236-7z" fill="#2B2B2B" fill-rule="evenodd"/></svg></button>'
      });
    }
  }
};